"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const HeroCarousel = dynamic(
    () => import("./HeroCarousel").then((m) => ({ default: m.HeroCarousel })),
    { ssr: false },
);

type IdleWindow = Window & {
    requestIdleCallback?: (
        cb: IdleRequestCallback,
        opts?: IdleRequestOptions,
    ) => number;
    cancelIdleCallback?: (handle: number) => void;
};

export function HeroCarouselGate() {
    const [shouldMount, setShouldMount] = useState(false);

    useEffect(() => {
        const w = window as IdleWindow;
        let idleHandle: number | undefined;
        let timeoutHandle: ReturnType<typeof setTimeout> | undefined;

        if (typeof w.requestIdleCallback === "function") {
            idleHandle = w.requestIdleCallback(() => setShouldMount(true), {
                timeout: 3000,
            });
        } else {
            timeoutHandle = setTimeout(() => setShouldMount(true), 1500);
        }

        return () => {
            if (idleHandle !== undefined && w.cancelIdleCallback) {
                w.cancelIdleCallback(idleHandle);
            }
            if (timeoutHandle !== undefined) clearTimeout(timeoutHandle);
        };
    }, []);

    if (!shouldMount) return null;
    return <HeroCarousel />;
}
